import { cronHttp } from "api/cronHttp";
import { http } from "api/http";

const getGstrRecords = ({ queryKey }: any) => {
  let {
    limit,
    offset,
    query,
    type,
    selectedYear = "",
    rtntype = "",
    category,
    subCategory,
    status,
    jurisdiction,
    filingType,
  } = queryKey[1] || {};

  return http.get("/gstr", {
    params: {
      limit,
      offset,
      type,
      selectedYear,
      rtntype,
      category,
      subCategory,
      status,
      jurisdiction,
      filingType,
      ...query,
    },
  });
};

// One request for pages tracking two independent registrations per client
// (CMP-08 + GSTR-4X, GSTR-9 + GSTR-9C) instead of a separate GET /gstr per
// rtntype. Pass rtntypes as an array; the backend expects a comma-separated
// list and returns { [rtntype]: { count, result } } for each one requested.
const getGstrRecordsCombined = ({ queryKey }: any) => {
  let {
    limit,
    offset,
    query,
    type,
    selectedYear = "",
    rtntypes = [],
    category,
    subCategory,
    status,
    jurisdiction,
    filingType,
  } = queryKey[1] || {};

  return http.get("/gstr/combined", {
    params: {
      limit,
      offset,
      type,
      selectedYear,
      rtntype: Array.isArray(rtntypes) ? rtntypes.join(",") : rtntypes,
      category,
      subCategory,
      status,
      jurisdiction,
      filingType,
      ...query,
    },
  });
};

const exportGstr1 = (data: any) => {
    return cronHttp.post("/gstr/exportgstr1", data);
};

const exportGstr2x = (data: any) => {
    return cronHttp.post("/gstr/exportgstr2x", data);
};

const exportGstr3b = (data: any) => {
    return cronHttp.post("/gstr/exportgstr3b", data);
};

const exportGstrCmp8 = (data: any) => {
    return cronHttp.post("/gstr/exportgstrcmp8", data);
};

const exportGstrCmp8Combined = (data: any) => {
    return cronHttp.post("/gstr/exportgstrcmp8combined", data);
};

const exportGstr4 = (data: any) => {
    return cronHttp.post("/gstr/exportgstr4", data);
};

const exportGstr9 = (data: any) => {
    return cronHttp.post("/gstr/exportgstr9", data);
};

const exportGstr9Combined = (data: any) => {
    return cronHttp.post("/gstr/exportgstr9combined", data);
};

const exportGstrtaxdeductor = (data: any) => {
    return cronHttp.post("/gstr/exportgstrdeductor", data);
};

const exportGstrtaxCollector = (data: any) => {
    return cronHttp.post("/gstr/exportgstrcollector", data);
};

const exportGstrtaxdistributor = (data: any) => {
    return cronHttp.post("/gstr/exportgstrdistributor", data);
};

const exportGstr9c = (data: any) => {
    return cronHttp.post("/gstr/exportgstr9c", data);
};
const removeGstrRegistrations = (ids: number[]) => {
  return http.delete("/gstr", { data: { ids } });
};

const getGstrClientRecords = ({ queryKey }: any) => {
  return http.get("/gstr/compliance", { params: { ...queryKey[1] } });
};

const getClients = ({ queryKey }) => {
  return http.get("/gstr/clients", { params: { ...queryKey[1] } });
};


const createGstrClient = (data: any) => {
  return http.post("/gstr", data);
};

const createGstrPromiseClient = (data: any) => {
  return http.post("/promise", data);
};

const getSingleClientReturns = (data: any) => {
  return http.post("/promise/client", data);
};

const syncSingleClientReturns = (data: any) => {
  return http.post("/promise/client-sync", data);
};

const clearPending = () => {
  return http.get("/promise/status");
};

const exportComplianceGstr1 = (data: any) => {
  return http.post("/gstr/exportcompliance-gstr1", data);
};

const exportComplianceGstr2x = (data: any) => {
  return http.post("/gstr/exportcompliance-gstr2x", data);
};

const exportComplianceGstr3b = (data: any) => {
  return http.post("/gstr/exportcompliance-gstr3b", data);
};

const exportComplianceGstrCmp8 = (data: any) => {
  return http.post("/gstr/exportcompliance-gstrcmp8", data);
};

const exportComplianceGstr4 = (data: any) => {
  return http.post("/gstr/exportcompliance-gstr4", data);
};

const exportComplianceGstr9 = (data: any) => {
  return http.post("/gstr/exportcompliance-gstr9", data);
};

const exportComplianceGstr9c = (data: any) => {
  return http.post("/gstr/exportcompliance-gstr9c", data);
};

const exportComplianceGstrtaxdeductor = (data: any) => {
  return http.post("/gstr/exportComplianceGstrtaxdeductor", data);
};

const exportComplianceGstrtaxdistributor = (data: any) => {
  return http.post("/gstr/exportComplianceGstrtaxdistributor", data);
};

const exportComplianceGstrtaxCollector = (data: any) => {
  return http.post("/gstr/exportComplianceGstrtaxCollector", data);
};

const exportGstClientReport = (data: any) => {
  return http.post("/gstr-client/export-gst-report", data, {
    responseType: "blob", // important for excel download
  });
};

export {
  getGstrRecords,
  getGstrRecordsCombined,
  removeGstrRegistrations,
  getGstrClientRecords,
  getClients,

  createGstrClient,
  createGstrPromiseClient,
  getSingleClientReturns,
  syncSingleClientReturns,
//   clearPending,

  exportGstr1,
  exportGstr2x,
  exportGstr3b,
  exportGstrCmp8,
  exportGstrCmp8Combined,
  exportGstr4,
  exportGstr9,
  exportGstr9Combined,
  exportGstr9c,
  exportGstrtaxdeductor,
  exportGstrtaxCollector,
  exportGstrtaxdistributor,

  exportComplianceGstr1,
  exportComplianceGstr2x,
  exportComplianceGstr3b,
  exportComplianceGstrCmp8,
  exportComplianceGstr4,
  exportComplianceGstr9,
  exportComplianceGstr9c,
  exportComplianceGstrtaxCollector,
  exportComplianceGstrtaxdeductor,
  exportComplianceGstrtaxdistributor,

  exportGstClientReport,
};
